import common from '@page/common/js/common';
import RenderProductListContent from '@page/productListStatic/js/ProductListContent';
import productListUI from '@page/common/js/productList/productListUI';
import $ from 'jquery';

require('sticky-kit/dist/sticky-kit');

window.mq.productConfig = {
  stickyListMenu: true,
  templateVersion: 3,
  hasWishList: true,
  sizeSelectorTypeDesktop: 'dropdown',
  imageBasePath: '//pazzo.cloudcdn.tw/meierq/',
  zoomboxData: 'JumboImage',
  refreshDOMs: ['.product-photos__jumbo', '.product-size'],
  imgPath: {
    s: 's',
    l: '',
  },
};

RenderProductListContent();

setTimeout(() => {
  $('.items__image').css('opacity', '1');
}, 100);
